import {
    USER_SUBMIT_FRUI_ZZZZ_BEGIN,
    USER_SUBMIT_FRUI_ZZZZ_SUCCESS,
    USER_SUBMIT_FRUI_ZZZZ_FAILURE,
    USER_SUBMIT_FRUI_ZZZZ_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_zzzz(params,igasvID) {
  console.log(params)
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_ZZZZ_BEGIN,
      });

    const promise = new Promise((resolve, reject) => {
        request({
          url:`/api/basic/company/quality/${params.igasvID}`,
          data: params,
          method:'put'
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_ZZZZ_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_ZZZZ_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_zzzzError() {
    return {
      type: USER_SUBMIT_FRUI_ZZZZ_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_ZZZZ_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_zzzzPending: true,
          submitFrui_zzzzError: null,
        };
  
      case USER_SUBMIT_FRUI_ZZZZ_SUCCESS:
        // The request is success
        console.log(action.data)
        return {
          ...state,
          submitFrui_zzzzPending: false,
          submitFrui_zzzzError: null,
        };
  
      case USER_SUBMIT_FRUI_ZZZZ_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_zzzzPending: false,
          submitFrui_zzzzError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_ZZZZ_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_zzzzError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_zzzz.js